export const TotalBreadcrumbContent = {
  giftingAmount: `Est. total gift thus far: `,
};
